import { connect } from "react-redux";
import { ItemUpdateProgress } from "../shared/ItemUpdateProgress";
import { downloadInboundReceipt, downloadOutboundReceipt, getItemUpdateTask } from "../../app/store/actions/imsAdminActions";

const AdminItemUpdateProgress = (props) => (
    <ItemUpdateProgress
        {...props}
        historyPath="/ims/admin/item-updates"
        homePath="/ims/admin"
        inboundsPath="/ims/admin/inbounds"
    />
);

export default connect(null, { getItemUpdateTask, downloadOutboundReceipt, downloadInboundReceipt })(AdminItemUpdateProgress);
